<template>
  <div class="c-navigation">
    <div class="c-navigation__group" v-for="group in routes" :key="group.group">
      <h2 class="c-navigation__title">{{ group.group }}</h2>
      <ul class="c-navigation__list">
        <li
          class="c-navigation__item"
          v-for="route in group.routes"
          :key="route.path"
        >
          <router-link class="c-navigation__link" :to="route.path">
            <span
              v-for="(part, index) in splitPath(route.path)"
              :key="`${part}${index}`"
            >
              {{ part }}
            </span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import routes from '@/routes.json'

export default {
  name: 'OPrototypeNavigation',
  data: () => ({
    routes
  }),
  methods: {
    splitPath(path) {
      return path.split('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.c-navigation {
  background: #fff;
  flex: none;
  overflow-y: auto;
  width: 32rem;
}

.c-navigation__title {
  display: block;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.6rem;
  margin: 2.4rem 1.6rem 1.6rem;
}

.c-navigation__list {
  margin-bottom: 1.6rem;
}

.c-navigation__item {
  display: block;
  font-size: 1.3rem;
}

.c-navigation__link {
  display: block;
  overflow: hidden;
  padding: 0.4rem 1.6rem;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    background: $background-color;
  }

  &.router-link-exact-active {
    background: $primary-color;
    background: var(--primary-color);
    color: #fff;
  }

  span + span:before {
    content: ' / ';
    font-weight: normal;
    opacity: 0.5;
  }

  span:last-child {
    font-weight: bold;
  }
}

@media (max-width: 50em) {
  .c-navigation {
    display: none;
  }
}
</style>
